import { useEffect, useState } from "react";
import { useBaaanggg } from "./BaaangggHook";
import { ChainResponse } from "baaanggg";

export function useChains() {
    const [chains, setChains] = useState<ChainResponse[]>([]);
    const baaanggg = useBaaanggg()

    const fetchChain = async () => {
        const chains = await baaanggg.chain.all()
        setChains(chains)
    }

    useEffect(() => {
        fetchChain()
    }, [])

    return chains
}